// ** React Imports
import { Fragment, useContext } from "react"
import { StoreContext } from "@customstore/StoreProvider"
// // ** Third Party Components
import classnames from 'classnames'
// ** Custom Hooks
import { useNotificacion } from "@hooks/useNotificacion"
import { types } from '@customstore/storeReducer'

import { Badge } from 'reactstrap'

import { useNavigate } from 'react-router-dom'
import { elapsedTime } from '@utils'

import Moment from 'moment'
import 'moment/locale/es-mx'

const ItemDropdown =  ({data, clickNotificacionHandler}) => {
  Moment.locale('es-mx')
  const {
    administrar
  } = useNotificacion([])
  
  const [store, dispatch] = useContext(StoreContext)
  const {
    loadNuevas,
    defaultFiltros
  } = useNotificacion([])

  const LayoutA =  () => {
    
    return <Fragment>
            <div className="d-flex flex-nowrap justify-content-between list-item-body w-100 ">
              <div className="ww-80A  fw-bolder">{data.titulo}</div>
              <div className="ww-80 mr-auto text-end"><small>{elapsedTime(data.createdAt)}</small></div>
            </div>
            <small className="notification-text p-0 m-0 w-100"> {data.mensaje}</small>
            <div className="w-100 mr-auto mmt-1" ><Badge color='light-success' pill className={data.status ? 'hidden' :  ' d-block badge-glow' }> Nueva</Badge></div>
          </Fragment>
  }
  

  const LayoutB =  () => {
    return <Fragment>
      <div className="d-flex flex-nowrap justify-content-between list-item-body w-100 ">
        <div className="ww-80A  fw-bolder">{data.titulo}</div>
        <div className="ww-80 mr-auto text-end"><small>{elapsedTime(data.createdAt)}</small></div>
      </div>
      <div className="w-100 mr-auto mmt-1" ><Badge color='light-success' pill className={data.status ? 'hidden' :  ' d-block badge-glow' }> Nueva</Badge></div>
    </Fragment>
  }
  return <a
    className="d-flex"
    onClick={(e) => {
        e.preventDefault()
        clickNotificacionHandler(data)
    }}
  >
    <div
      className={classnames("list-item d-flex  flex-wrap", {
      })}
    >
      { data.mensaje ?
        LayoutA() : 
        LayoutB()
      }
    </div>
  </a>
}

export default ItemDropdown
